import { useState } from "react";
import { fetchApi } from "../utils/common";
import { APIError } from "../core/errors";

export const useApi = () => {
  // レスポンスデータ
  const [data, setData] = useState(null);
  //   ロード中フラグ
  const [isLoading, setIsLoading] = useState(false);
  // エラー{}
  const initialErrorState = { status: null, message: "" };
  const [error, setError] = useState(initialErrorState);

  //   Fetcth実行
  const fetchData = async (url, method, requestBody) => {
    // const API_URL_ORIGIN = process.env.API_URL_ORIGIN;
    // console.log(process.env.API_URL_ORIGIN);
    setIsLoading(true);
    setError(initialErrorState);
    try {
      // fetch呼び出し
      const jsonData = await fetchApi(url, method, requestBody);
      setData(jsonData);
      //   基本はstatusのdataを使うが、戻り値も使用可能にする
      return jsonData;
    } catch (e) {
      if (e instanceof APIError) {
        setError({ status: e.status, message: e.message });
        // 認証エラー(ログインのみでしか使わない想定)
        if (e.status === 422) return null;
        // 認証失敗
        if (e.status === 401) {
          return;
        } else {
          // その他APIエラー
          return;
        }
      } else {
        setError({ message: e.message });
        alert(e.status + "error!!!");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, error, fetchData };
};
